import HttpService from "@/services/HttpService";
import store from "@/store";
export default {
  getCart() {
    return HttpService.get("cart", "", true);
  },

  addToCart(data) {
    return HttpService.post("cart", data, true);
  },

  updateCart(items) {
    return HttpService.put("cart", { items }, true);
  },

  removeItem(productId) {
    return HttpService.delete(`cart/${productId}`, true);
  },

  clearCart() {
    return HttpService.delete("cart/clear", true);
  },
};
